import { render, staticRenderFns } from "./PluginsAndThemes.vue?vue&type=template&id=6b694ca8&scoped=true&"
import script from "./PluginsAndThemes.vue?vue&type=script&lang=js&"
export * from "./PluginsAndThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b694ca8",
  null
  
)

export default component.exports